import { useStyles } from './styles'
import { $userLanguage, $userToken, authUserFx } from '@/entities/user'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { BackgroundShading } from '@/shared/ui/backgroundShading'
import { useEffect, useMemo } from 'react'
import { useBackButton } from '@/shared/hooks/useBackButton'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { DailyBonusLocker } from '@/shared/ui/dailyBonusLocker'

import { $farcanaBonusRewards, $farcanaBonusStreak } from '@/entities/dailyBonus/model/store'

import { getFarcanaBonusInfoFx } from '@/entities/dailyBonus/model/effects'
import WebApp from '@twa-dev/sdk'
import { HardWareGiveaway } from '@/shared/ui/hardwareGiveaway'
import { FarcanaDailyBonusRow } from '@/features/dailyBonusRow/farcana'
import AppLoading from '@/features/loading'

export const FarcanaDailyBonus = () => {
  useHideNav()

  const { classes } = useStyles()
  const userToken = useUnit($userToken)
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.dailyBonus
  const streak = useUnit($farcanaBonusStreak)
  const farcanaBonusRewards = useUnit($farcanaBonusRewards)
  const totalClaimedRewards = farcanaBonusRewards?.filter((item) => item.is_claimed).length ?? 1
  const lockerMultiplier = totalClaimedRewards > streak ? totalClaimedRewards : streak

  useEffect(() => {
    if (!userToken) {
      authUserFx({ init_data: WebApp.initData })
      return
    }
    getFarcanaBonusInfoFx(userToken)
  }, [userToken])
  const noLocker = useMemo(() => {
    if (!farcanaBonusRewards) return true
    if (farcanaBonusRewards.length === totalClaimedRewards) {
      return true
    }
    return false
  }, [farcanaBonusRewards, totalClaimedRewards])

  const DEFAULT_GAP = 293
  const WRAPPER_HEIGHT = 141

  const lockerMargin = DEFAULT_GAP + WRAPPER_HEIGHT * lockerMultiplier

  useBackButton({})

  if (!farcanaBonusRewards) return <AppLoading />

  return (
    <div className={classes.root}>
      {!noLocker && (
        <div
          className={classes.lockerWrapper}
          style={{
            transform: `translateY(${lockerMargin}px)`,
          }}
        >
          <DailyBonusLocker lockIconStyles={{ left: '16%' }} />
        </div>
      )}
      <div className={classes.bgWrapper}>
        <img
          src="/assets/backgrounds/dailyBonusFarcana.webp"
          alt=""
          className={classes.background}
        />
        <div className={classes.textWrapper}>
          <h1 className={classes.heading}>{texts.farcana.heading}</h1>
          <h2 className={classes.subHeading}>{texts.farcana.subHeading}</h2>
        </div>
        <BackgroundShading
          height="120px"
          top="14px"
        />
      </div>

      <div className={classes.hardwareWrapper}>
        <HardWareGiveaway
          heading={texts.farcana.hardwareHeading}
          description={texts.farcana.hardwareDescription}
          img="/assets/backgrounds/playstationWithPack.webp"
          headingStyles={{ fontSize: '20px' }}
          justifyContent="space-between"
          gap={4}
          minHeight={120}
          maxHeight={150}
          height={'auto'}
        />
      </div>

      <div>
        {farcanaBonusRewards.map((item, idx) => {
          return (
            <FarcanaDailyBonusRow
              key={idx}
              isClaimed={item.is_claimed}
              reward={item.reward}
              rewardKind={item.kind}
              currentDay={item.day}
              canClaim={item.can_claim}
            />
          )
        })}
      </div>
    </div>
  )
}
